import { createBrowserHistory } from 'history'
import { configureStore } from '@reduxjs/toolkit'
// import logger from 'redux-logger'
import RootReducer from './rootReducer'
import { refreshTokenThunk } from './auth/thunks'
import { appLogOutAction } from './auth/slice'
import { useDispatch, useSelector, useStore } from 'react-redux'

export const history = createBrowserHistory()

export const store = configureStore({
  reducer: RootReducer(history),
  devTools: process.env.NODE_ENV === 'development',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['uploadImages'],
        ignoredActionPaths: ['meta.arg', 'payload.images']
      }
    })
  // .prepend()
  // .concat(logger)
})

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppStore = useStore.withTypes<AppStore>()

export const authCallbacks = {
  refreshToken: () => store.dispatch(refreshTokenThunk()),
  appLogOut: () => store.dispatch(appLogOutAction())
}
